import App from './FunkGoApp'
import Link, { withLink } from './FunkGoLink'
import { createFunkGoPage } from './FunkGoPage'

import PluginContext from './PluginContext'
import FunkGoContext from './FunkGoContext'

import withPreventPageReload from './withPreventPageReload'
import withPlugin from './withPlugin'

import globalRoutes from './globalRoutes'

import BaseService from './base/BaseService'
import BasePlugin from './base/BasePlugin'

import Loadable from './Loadable'
import MyLoadable, { MyLoadableComponent } from './MyLoadable'

import createStorage from './utils/cache'


import hoistHocStatic from './utils/hoistHocStatic'

import render from './render'

import * as serviceWorker from './serviceWorker'
import * as webPushServiceWorker from './webPushServiceWorker'

import { useRouterHistory } from './adapters/CustomRouterHistoryContext'


export default App
export {
  render,
  serviceWorker,
  webPushServiceWorker,

  globalRoutes,

  PluginContext,
  FunkGoContext,

  withPlugin,
  withLink,

  withPreventPageReload,
  hoistHocStatic,

  BaseService,
  BasePlugin,

  Loadable,
  MyLoadable,
  MyLoadableComponent,
  Link,
  createStorage,
  createFunkGoPage,

  useRouterHistory
}
